
import { StopPresentation } from "../general/StopPresentation";
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { RoadRageEngineController } from "../../reel/RoadRageEngineController";
import { GameData } from "../../server/data/BaseModel";
import { CarMoveInfo, CarTypes } from '../../server/data/GameDataModels';
import { RoadRage } from '../../RoadRage';
import { RoadRageReelOverlay } from '../../reel/RoadRageReelOverlay';
import { PosterManager, FeaturePosterState } from '../../independent/poster/PosterManager';
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';

export class FSStopPresentation extends StopPresentation {

    private yellowCanBeSticky:boolean = false;
    private scatterLandCount:number = 0;

    protected carInfos: CarMoveInfo[];

    constructor() {
        super();
    }

    setGamedData(data: GameData): void {
        super.setGamedData(data);

        this.countScatter = RoadRageEngineManager.preferedLayoutSize;

        this.scatterLandCount = 0;

        this.carInfos = data.Reel.carMoveInfo.filter(c => c.type === CarTypes.YELLOW);

        this.yellowCanBeSticky = Object.keys(this.gameData.fsInfo.fsCars).indexOf("WC3") >= 0;
    }

    preStart(): void {
        super.preStart();
    }

    public createPresentation(enableSkip: Function) {
        enableSkip(!RoadRageEngineManager.isQuickStop);

        if (this.readyToDefineStop()) {

            this.createStopSpins();

            const delay: number[] = this.defineDelays();

            RoadRageEngineManager.stopReels(delay);

            // if (this.attentionSoundStarted) {
            //     SoundManager.stopSoundEffect(SoundConfig.SCATTER_ANTICIPATION);
            //     SoundManager.playSoundEffect(SoundConfig.SCATTER_ANTICIPATION_END);
            //     SoundManager.fadeInAmbient(700);
            // }
        }
    }

    createStopSpins(): void {
        RoadRageEngineManager.RAll((rc: RoadRageEngineController) => rc.createStop({
            stops: () => this.onStops(rc),
            bounce: () => this.onBounce(rc),
            stopped: () => this.onStopped(rc)
        },false));
    }

   
    defineDelays(): number[] {

        const delay: number [] = this.basicStopDelay;

        this.carDelay(delay);
       
        if (this.scatterDelay(delay)) {
            this.winHitDelay(delay);
        }

        return delay;
    }

    carDelay(delay: number[]): boolean {

        let delays: number = 0;
        let addedDelay: number = 0;
        
        for (let i: number = 0; i < delay.length; i++) {
            if(this.gameData.Reel.lastStickies.find(s => s.reel === i) || this.gameData.Reel.isCarOnReel(i))
                addedDelay += 0.1;
        }

        for (let i: number = 0; i < delay.length; i++) {
            delay[i] += delays;
            delays += addedDelay;
        }
        return false;
    }

    scatterDelay(delay: number[]): boolean {
        let delays: number = 0;
        for (let i: number = 0; i < delay.length; i++) {
            delay[i] += delays;
            if (this.scatterPos[i] >= 0) {
                delays += 2;
            }
        }

        return false;
    }

    winHitDelay(delay: number[]): void {
        if (this.possibleWin.length <= 2) return;
        let delays: number = 0;
        for (let i: number = 2; i < delay.length; i++) {
            delay[i] += delays;

            if (this.possibleWin.length - 1 > i)
                delays += 0.1 + i * 0.1;
            else {
                delays += 0.1 + i * 0.1;
                break;
            }
        }
    }

    onStops(rc: RoadRageEngineController): void {
        rc.setGraphAlpha(0, rc.stopDuration);
    }

    onBounce(rc: RoadRageEngineController): void {
              
        const addAmm:number = this.gameData.fsInfo.fsCars["WC3"] ? this.gameData.fsInfo.fsCars["WC3"][1] : 1;
        
        const startPos: number = this.animationTl.time();
        if (this.gameData.Reel.YellowCarPositions[rc.reelID].length ) {

            let isOccupied:boolean = false;
            for( let k = 0; k < this.gameData.Reel.YellowCarPositions[rc.reelID].length;k++){
                rc.AllSticky.forEach(s => {
                    if(s.posID[0] === this.gameData.Reel.YellowCarPositions[rc.reelID][k]){
                        isOccupied = true;
                    }
                })

            }
            if(!isOccupied){
                let upgrades:boolean = false;

                rc.AllOrderSymbols.forEach(s => {
                    if (!s.isCar || (s.isCar && s.state.equal("Sticky"))) {
                        this.animationTl.add(s.addMult(addAmm, undefined, true), startPos);
                        this.animationTl.add(() => { s.Explosion() }, startPos);
                        this.animationTl.to(this,{duration:0.05})
                    }
                });
    
                this.animationTl.add(() => {
                    if(upgrades){
                        SoundManager.playSoundEffect(SoundConfig.MULT_LAND_UPGRADE)
                    }else{
                        SoundManager.playSoundEffect(SoundConfig.MULT_LAND)
                    }
                },startPos+0.8)
            }
        }

        // this.flashCarDirection(rc);
        this.onScatterHits(rc);
        this.playBounceSound(rc.reelID);
        
        rc.AllWindowSymbols.forEach(s => {
            if(this.gameData.Reel.lastStickies.findIndex(sI => sI.reel === rc.reelID && sI.row === s.posID[0] ) >= 0)
                s.hideBehindSticky(rc.engine.timeLeft)
            else{
                s.onBounceEffect(rc.engine.timeLeft, this.yellowCanBeSticky);
                if(s.isMystery){
                    this.animationTl.add(s.playBounceMystery(),startPos);
                }
            }
        });

        this.possibleWinNonWins(rc.reelID);
    }

    onStopped(rc: RoadRageEngineController): void {
        rc.mergeSticky();
        RoadRageReelOverlay.instance.setDisabled(this.gameData.Reel.reelsWithScatters[rc.reelID], rc.reelID);

       if(this.scatterPos[rc.reelID] >= 0 && this.gameData.Reel.lastStickies.findIndex(sI => sI.reel === rc.reelID && sI.row === this.scatterPos[rc.reelID] ) == -1){
            debugger;
            PosterManager.instance.play(FeaturePosterState.POSTER, { animation: this.scatterLandCount === 0 && this.gameData.Reel.reelModeHeight === 3 ? FeaturePosterState.POSTER_JAM : FeaturePosterState.POSTER_MAYHEM, showOnEnd:true }).add(
                () => { PosterManager.instance.moveDown(this.gameData.Reel.reelModeHeight === 3) },0.75);
            this.scatterLandCount++;
        }
    }

    resetPreWins(): void {
        RoadRageEngineManager.RSAll((r, s) => s.markNonWin(false, 0, 0.25));
        const startPos: number = this.animationTl.time();
        this.animationTl.to(this, { duration: 0.125 }, startPos);
    }

    skip(): void {
        super.skip();
    }

    done(): void {
        RoadRage.reelManager.applyMask(false);
        RoadRageEngineManager.RAll(r => r.attention(false));
        SoundManager.stopSoundEffect(SoundConfig.REELS_SPINNING);
    }
}